import { ReactComponent as TraditionalDependencySvg } from "../../../../src/images/traditional-dependency.svg";
import { ReactComponent as DependencyInversionSvg } from "../../../../src/images/dependency-inversion.svg";
import * as React from 'react';
export default {
  TraditionalDependencySvg,
  DependencyInversionSvg,
  React
};